import { useHistory } from './useHistory';

type NavigateDoneOverride = {
  orderName?: string;
  clockId?: string;
};

export const useNavigateDone = () => {
  const { push } = useHistory();

  const navigateToDone = (searchParam: NavigateDoneOverride) => {
    const orderName = searchParam?.orderName;
    const clockId = searchParam?.clockId;
    const search = `orderName=${orderName || clockId}`;
    push({ pathname: '/gift/done', search });
  };

  return navigateToDone;
};
